import React  from "react";
import { Table } from "react-bootstrap";

const TableTemplate = ({ theadStyle = {}, header, body }) => (
    <Table striped bordered className="table-template">
        <thead style={{ ...theadStyle }}>
            <tr>
                {
                    header.map(value => (
                        <th key={ value }>{ value }</th>
                    ))
                }
            </tr>
        </thead>
        { body() }
    </Table>
);

export default React.memo(TableTemplate);